<script setup lang="ts">
    import { CompanyGroup } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import Delete from '../Delete.vue';
    import EditCompanyGroup from './EditCompanyGroup.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';

    interface Props {
        companyGroup: CompanyGroup;
    }

    defineProps<Props>();

    const { hasPermission } = usePermissions();
</script>

<template>
    <DataTableActions :data="companyGroup">
        <EditCompanyGroup
            v-if="hasPermission(Permission.COMPANIES_UPDATE)"
            :company-group="companyGroup"
        />
        <Delete
            v-if="hasPermission(Permission.COMPANIES_DELETE)"
            :route="route('v2.company-groups.destroy', companyGroup.id)"
            :query-key="[QueryKey.COMPANY_GROUPS]"
            success-message="company-groups.deleted"
            error-message="company-groups.delete.error"
        />
    </DataTableActions>
</template>
